import React from 'react';
import {useIntl} from 'react-intl';
import {alpha, useTheme} from '@mui/material/styles';
import {SegmentedControl} from 'wobi-web-common/dist/v2/index.js';
import ErrorText from './ErrorText';

const MedicalSubQuestion = ({
  text,
  options,
  value,
  onChange,
  error,
  errorMessage,
  last,
  disabled,
  dataTestId,
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const resolvedOptions = options || [
    {value: 'yes', label: intl.formatMessage({id: 'yes'})},
    {value: 'no', label: intl.formatMessage({id: 'no'})},
  ];
  return <div
    className={`medical-subquestion${last ? ' medical-subquestion-last' : ''}`}
    style={{
      '--medical-divider': theme.palette.divider,
      '--medical-primary': theme.palette.primary.main,
      '--medical-primary-dark': theme.palette.primary.dark,
      '--medical-primary-soft': theme.palette.primary.lighter,
      '--medical-text': theme.palette.text.primary,
      '--medical-error': theme.palette.error.main,
      '--medical-focus-ring': alpha(theme.palette.secondary.main, 0.45),
      '--medical-font-family': theme.typography.fontFamily,
      '--medical-question-size': theme.typography.pxToRem(15.5),
      '--medical-weight-semibold': theme.typography.fontWeightSemiBold,
      '--medical-weight-bold': theme.typography.fontWeightBold,
    }}
  >
    <div className='medical-subquestion-label'>
      {text}
    </div>
    <div className='medical-question-options' data-testid={dataTestId}>
      <SegmentedControl
        className='medical-answer-control'
        ariaLabel={typeof text === 'string' ? text : intl.formatMessage({id: 'medical.answerAriaLabel'})}
        value={value}
        options={resolvedOptions}
        onChange={onChange}
        invalid={error}
        disabled={disabled}
      />
      {error && <ErrorText>{errorMessage}</ErrorText>}
    </div>
  </div>;
};

export default MedicalSubQuestion;
